var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50816 0.001162C7.42863 0.001162 8.99264 1.56517 8.99264 3.48762L8.99257 4.52455C10.1601 4.93088 11 6.04239 11 7.34686V10.1677C11 11.8153 9.66027 13.155 8.01274 13.155H2.98726C1.33973 13.155 0 11.8153 0 10.1677V7.34686C0 6.04263 0.839565 4.9313 2.00677 4.52478L2.00723 3.48762C2.01117 2.54053 2.37751 1.66645 3.0385 1.01139C3.70014 0.355661 4.57357 -0.0238305 5.50816 0.001162ZM8.01274 5.34614H2.98726C1.88365 5.34614 0.986547 6.24324 0.986547 7.34686V10.1677C0.986547 11.2713 1.88365 12.1684 2.98726 12.1684H8.01274C9.11569 12.1684 10.0135 11.2713 10.0135 10.1677V7.34686C10.0135 6.24324 9.11569 5.34614 8.01274 5.34614ZM5.49987 7.53351C5.77216 7.53351 5.99314 7.7545 5.99314 8.02679V9.48754C5.99314 9.75982 5.77216 9.98081 5.49987 9.98081C5.22758 9.98081 5.00659 9.75982 5.00659 9.48754V8.02679C5.00659 7.7545 5.22758 7.53351 5.49987 7.53351ZM5.50618 0.987709H5.49566C4.82941 0.987709 4.20526 1.24421 3.73369 1.71183C3.25883 2.18143 2.99641 2.80822 2.99378 3.47644L2.99318 4.35922H8.0055L8.00609 3.48762C8.00609 2.10908 6.88472 0.987709 5.50618 0.987709Z",
    fill: "#25242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5ea57f7fe7fd3942e96b087478f92ae0.svg";
export { ForwardRef as ReactComponent };